import { JSX, useMemo } from "react";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Chip, Theme, useTheme } from "@mui/material";

const getStyles = (fontSize: string, hasWhiteBackground: boolean, ml: number, theme: Theme) => ({
  differencePositive: {
    fontSize,
    ml,
    backgroundColor: hasWhiteBackground ? "white" : theme.palette.positive.bg,
    color: theme.palette.positive.text,
  },
  iconPositive: {
    fontSize,
    color: theme.palette.positive.text,
  },
  differenceNegative: {
    fontSize,
    ml,
    backgroundColor: hasWhiteBackground ? "white" : theme.palette.negative.bg,
    color: theme.palette.negative.text,
  },
  iconNegative: {
    fontSize,
    color: theme.palette.negative.text,
  },
});

function DifferenceChip({
  difference,
  fontSize,
  hasWhiteBackground = false,
  ml = 1,
}: {
  difference: number | null;
  fontSize: string;
  hasWhiteBackground?: boolean;
  ml?: number;
}): JSX.Element | null {
  const theme = useTheme();
  const styles = getStyles(fontSize, hasWhiteBackground, ml, theme);

  if (hasWhiteBackground) {
    styles.differencePositive.backgroundColor = "white";
    styles.differenceNegative.backgroundColor = "white";
  }

  const absoluteDiff = useMemo(() => `${Math.abs(difference ?? 0).toFixed(1)}%`, [difference]);

  if (!difference) {
    return null;
  }

  if (difference > 0) {
    return <Chip sx={styles.differencePositive} size='small' icon={<ArrowUpwardIcon style={styles.iconPositive} />} label={absoluteDiff} />;
  }

  return <Chip sx={styles.differenceNegative} size='small' icon={<ArrowDownwardIcon style={styles.iconNegative} />} label={absoluteDiff} />;
}

DifferenceChip.defaultProps = {
  hasWhiteBackground: false,
  ml: 1,
};

export default DifferenceChip;
